export default __webpack_public_path__ + "static/media/Card-GoPlatinumMastercard.ca155dc6.png";